import type { FallbackRender } from '@sentry/react'
import { Button } from '@/components/ui/button'

const ErrorFallback: FallbackRender = ({ error }) => (
  <div className="flex min-h-screen items-center justify-center p-4">
    <div className="text-center">
      <h2 className="mb-2 text-xl font-semibold text-destructive">Something went wrong</h2>
      <p className="text-muted-foreground">
        {error instanceof Error ? error.message : 'An unexpected error occurred'}
      </p>
      <Button className="mt-4" onClick={() => window.location.reload()}>
        Reload
      </Button>
    </div>
  </div>
)

export default ErrorFallback
